import { defineComponent, useListeners, inject } from 'vue';
import { useLocalizationSupport } from '../../../composables/localization-support/index.js';
import { useTableRow } from '../../../composables/table-row/index.js';
import { portfolioPositionsPerformanceFactory } from '../../portfolio-positions-performance/setup/index.js';
import { portfolioPositionsWeightFactory } from '../../portfolio-positions-weight/setup/index.js';
import { portfolioEvaluationChartFactory } from '../../portfolio-evaluation-chart/setup/index.js';
import { portfolioBreakdownFactory } from '../../portfolio-breakdown/setup/index.js';
import HoistComponent from '../../hoist-component/HoistComponent.vue.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PortfolioOverview",
  props: {
    locale: { type: null, required: true },
    id: { type: null, required: true }
  },
  emits: ["table-row-key-click", "table-row-click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const listeners = useListeners();
    const translator = inject("translator");
    const numberFormatter = inject("numberFormatter");
    const dateFormatter = inject("dateFormatter");
    const injectedStoreModule = inject("storeModule");
    const localizationSupport = useLocalizationSupport(props, { translator, numberFormatter, dateFormatter });
    const { translate } = localizationSupport;
    const PortfolioPositionsWeight = portfolioPositionsWeightFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: (injectedStoreModule == null ? void 0 : injectedStoreModule.getDependencies) ? injectedStoreModule.getDependencies().portfolioPositionsWeight : void 0
    });
    const PortfolioPositionsPerformance = portfolioPositionsPerformanceFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: (injectedStoreModule == null ? void 0 : injectedStoreModule.getDependencies) ? injectedStoreModule.getDependencies().portfolioPositionsPerformance : void 0
    });
    const PortfolioEvaluationChart = portfolioEvaluationChartFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: (injectedStoreModule == null ? void 0 : injectedStoreModule.getDependencies) ? injectedStoreModule.getDependencies().portfolioEvaluationChart : void 0
    });
    const PortfolioBreakdown = portfolioBreakdownFactory({
      translator,
      numberFormatter,
      dateFormatter,
      storeModule: (injectedStoreModule == null ? void 0 : injectedStoreModule.getDependencies) ? injectedStoreModule.getDependencies().portfolioBreakdown : void 0
    });
    const tableRow = useTableRow(listeners, emits);
    const { onTableRowClick } = tableRow;
    return { __sfc: true, props, emits, listeners, translator, numberFormatter, dateFormatter, injectedStoreModule, localizationSupport, translate, PortfolioPositionsWeight, PortfolioPositionsPerformance, PortfolioEvaluationChart, PortfolioBreakdown, tableRow, onTableRowClick, HoistComponent };
  }
});

export { _sfc_main as default };
